export function cf(value: string) {
  return (
    value &&
    `${value}`.match(
      /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i
    )
  );
}
export function phone(value: string) {
  return (
    value && `${value}`.match(/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/i)
  );
}

export function int(value: string) {
  const x = parseInt(value, 10);
  return isNaN(x) ? 0 : x;
}

export function currency(value: string) {
  const splitter = value.includes(",") ? "," : value.includes(".") ? "." : null;

  if (splitter) {
    const splittedVal = value.split(splitter);
    return splittedVal[0] + splitter + splittedVal[1].substring(0, 2);
  }

  return value;
}

export function formatPrice(value: number) {
  return Intl.NumberFormat("it-IT", {
    style: "currency",
    minimumFractionDigits: 2,
    currency: "EUR",
    currencyDisplay: "symbol",
  }).format(value);
}

export function email(value: string) {
  return value.match(
    /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
  );
}
